<template>
    <ul class="ideas-nav-groups">
        <li
            v-for="group in groups"
            :key="group.id"
            :class="['duration-nav-item', { expanded: isExpanded(group) }]"
        >
            <span class="duration-header">{{ group.name }}</span>
            <ul class="trip-nav-list">
                <li v-for="idea in leadingItems(group)" :key="idea.id">
                    <a
                        :href="'#idea-' + idea.id"
                        @click.prevent="$emit('select', idea)"
                    >
                        {{ idea.short_title || idea.title }}
                    </a>
                </li>
            </ul>
            <div
                v-if="isCollapsible(group)"
                class="trip-nav-extra"
                :inert="!isExpanded(group)"
            >
                <ul class="trip-nav-list">
                    <li v-for="idea in trailingItems(group)" :key="idea.id">
                        <a
                            :href="'#idea-' + idea.id"
                            @click.prevent="$emit('select', idea)"
                        >
                            {{ idea.short_title || idea.title }}
                        </a>
                    </li>
                </ul>
            </div>
            <button
                v-if="isCollapsible(group)"
                type="button"
                class="ideas-nav-more"
                :aria-expanded="isExpanded(group)"
                :aria-label="toggleLabel(group)"
                @click="toggle(group, $event)"
            >
                <template v-if="isExpanded(group)">
                    <span class="material-symbols-outlined">expand_less</span>
                    Show less
                </template>
                <template v-else>...</template>
            </button>
        </li>
    </ul>
</template>

<script>
const COLLAPSED_LIMIT = 3;

export default {
    name: "SavedIdeasNav",
    props: {
        groups: {
            type: Array,
            required: true,
        },
        collapsible: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["select"],
    data() {
        return {
            expandedGroupId: null,
        };
    },
    methods: {
        isCollapsible(group) {
            return this.collapsible && group.items.length > COLLAPSED_LIMIT;
        },
        isExpanded(group) {
            return this.expandedGroupId === group.id;
        },
        leadingItems(group) {
            return this.isCollapsible(group)
                ? group.items.slice(0, COLLAPSED_LIMIT)
                : group.items;
        },
        trailingItems(group) {
            return group.items.slice(COLLAPSED_LIMIT);
        },
        toggleLabel(group) {
            return this.isExpanded(group)
                ? `Show fewer ${group.name} ideas`
                : `Show all ${group.items.length} ${group.name} ideas`;
        },
        toggle(group, event) {
            if (this.isExpanded(group)) {
                this.expandedGroupId = null;
                return;
            }
            this.expandedGroupId = group.id;
            if (event.detail === 0) {
                const item = event.currentTarget.closest("li");
                this.$nextTick(() =>
                    item.querySelector(".trip-nav-extra a")?.focus()
                );
            }
        },
    },
};
</script>
